export default "__VITE_ASSET__JvYv5Yto__"